export type BootstrapModule = typeof import('./bootstrap');

try {
	await import('./bootstrap');
} catch (err) {
	console.error(err);
}
